// import React from "react";
// import jsPDF from "jspdf";
// import moment from "moment-jalaali";
// import { registerIranSans } from "../../assets/font/IRANSANS";
//
// const ReportPdf = ({ data }) => {
//   console.log(data, "asdkjfejjeejuuu");
//   const generatePdf = () => {
//     const doc = new jsPDF();
//
//     // فعال‌سازی فونت فارسی
//     registerIranSans(doc); // 📌 فونت رو اضافه کن
//     doc.setFont("IRANSANS");
//     doc.setFontSize(14);
//
//     // تبدیل زمان یونیکس به تاریخ شمسی
//     const formattedDate = moment
//       .unix(data?.inputData?.created_at)
//       .format("jYYYY/jMM/jDD");
//
//     // نوشتن اطلاعات
//     doc.text(`شماره موبایل: ${data?.inputData?.user_mobile}`, 10, 20);
//     doc.text(`مبلغ کل: ${data?.inputData?.amount} تومان`, 10, 30);
//     doc.text(`مبلغ قابل پرداخت: ${data?.inputData?.should_pay} تومان`, 10, 40);
//     doc.text(`وضعیت: ${data?.inputData?.status}`, 10, 50);
//     doc.text(`نوع تراکنش: ${data?.inputData?.type}`, 10, 60);
//     doc.text(`تاریخ ایجاد: ${formattedDate}`, 10, 70);
//
//     doc.save("transaction.pdf");
//   };
//
//   return (
//     <div>
//       <button onClick={generatePdf}>ReportPdf</button>
//     </div>
//   );
// };
//
// export default ReportPdf;

// import React from "react";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import moment from "moment-jalaali";
// import { registerIranSans } from "../../assets/font/IRANSANS";
//
// const ReportPdf = ({ data }) => {
//   const generatePdf = () => {
//     const doc = new jsPDF();
//     registerIranSans(doc);
//     doc.setFont("IRANSANS");
//     doc.setFontSize(14);
//
//     const formattedDate = moment
//       .unix(data?.inputData?.created_at)
//       .format("jYYYY/jMM/jDD");
//
//     // جدول با عناوین و اطلاعات
//     autoTable(doc, {
//       styles: { font: "IRANSANS", fontSize: 12, halign: "right" },
//       head: [["عنوان", "مقدار"]],
//       body: [
//         ["شماره موبایل", data?.inputData?.user_mobile],
//         ["مبلغ کل", `${data?.inputData?.amount} تومان`],
//         ["مبلغ قابل پرداخت", `${data?.inputData?.should_pay} تومان`],
//         ["وضعیت", data?.inputData?.status],
//         ["نوع تراکنش", data?.inputData?.type],
//         ["تاریخ ایجاد", formattedDate],
//       ],
//       margin: { top: 20 },
//     });
//
//     doc.save("transaction.pdf");
//   };
//
//   return (
//     <div>
//       <button onClick={generatePdf}>ساخت PDF</button>
//     </div>
//   );
// };
//
// export default ReportPdf;

// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { registerIranSans } from "../../assets/font/IRANSANS";
//
// const ReportPdf = () => {
//   const generatePdf = () => {
//     const doc = new jsPDF({ orientation: "p", unit: "mm", format: "a4" });
//     registerIranSans(doc);
//     doc.setFont("IRANSANS");
//
//     // تیتر اصلی
//     doc.setFontSize(16);
//     doc.text("صورت حساب الکترونیکی فروش", 105, 20, { align: "center" });
//
//     // اطلاعات فروشنده و خریدار
//     autoTable(doc, {
//       startY: 30,
//       styles: { font: "IRANSANS", fontSize: 10, halign: "right" },
//       bodyStyles: {
//         font: "IRANSANS", // ✅ و برای بدنه هم محکم‌کاری کن
//         fontStyle: "normal",
//         fontSize: 12,
//         halign: "right", // راست‌چین برای فارسی
//       },
//       theme: "grid",
//       body: [
//         [
//           {
//             content: `
// نام شرکت: آسمان خودرو آینده ایرانیان (سهامی خاص)
// شماره ثبت: 603528
// شماره ملی: 1401593151
// کد اقتصادی: 1401593151
// نشانی شرکت: تهران - جهاد خیابان فتحی شقاقی ساختمان سبز پلاک 50 طبقه 3 واحد 14
// تلفن: 1431784116
// کد پستی: 1431784116
//             `.trim(),
//             styles: { valign: "top" },
//           },
//           {
//             content: `
// خریدار: محمد محمدی
// شماره تلفن: 0901258961
// محل دریافت خدمات: تهران - جهاد خیابان فتحی شقاقی ساختمان سبز پلاک 50 طبقه 3 واحد 14
// نام خودرو: پژو 206 تیپ 2
// کارکرد: 1000 کیلومتر
// سال ساخت: 1402
//             `.trim(),
//             styles: { valign: "top" },
//           },
//           {
//             content: `فروشنده`.trim(),
//
//             styles: { valign: "top" },
//           },
//         ],
//       ],
//       columnStyles: {
//         0: { cellWidth: 40 },
//         1: { cellWidth: 100 },
//         2: { cellWidth: 20 },
//       },
//     });
//
//     // جدول اصلی اقلام
//     autoTable(doc, {
//       styles: { font: "IRANSANS", fontSize: 10, halign: "center" },
//       headStyles: {
//         font: "IRANSANS", // ✅ حتماً اینجا هم مشخص کن
//         fontStyle: "normal",
//         fontSize: 10,
//         halign: "center", // وسط‌چین کردن متن فارسی
//         cellWidth: 20,
//       },
//       bodyStyles: {
//         font: "IRANSANS", // ✅ و برای بدنه هم محکم‌کاری کن
//         fontStyle: "normal",
//         fontSize: 12,
//         halign: "right", // راست‌چین برای فارسی
//       },
//
//       startY: doc.lastAutoTable.finalY + 5,
//       head: [
//         [
//           "ردیف",
//           "شناسه کالا",
//           "شرح کالا",
//           "تعداد",
//           "مبلغ واحد (ریال)",
//           "مبلغ کل (ریال)",
//           "تخفیف (ریال)",
//           "مبلغ کل پس از تخفیف (ریال)",
//           "جمع مالیات و عوارض",
//           "جمع کل نهایی (ریال)",
//         ],
//       ],
//       body: [
//         [
//           "1",
//           "100",
//           "باطری صبا",
//           "1",
//           "3,000,000",
//           "3,000,000",
//           "0",
//           "3,000,000",
//           "0",
//           "3,000,000",
//         ],
//         [
//           "2",
//           "101",
//           "فیلتر هوا",
//           "1",
//           "1,600,000",
//           "1,600,000",
//           "0",
//           "1,600,000",
//           "0",
//           "1,600,000",
//         ],
//         ["", "", "جمع کل", "", "", "", "", "4,600,000", "0", "4,600,000"],
//       ],
//     });
//
//     // یادداشت پایانی و زمان
//     doc.setFontSize(10);
//     const finalY = doc.lastAutoTable.finalY + 10;
//     doc.text("اعتبار مالیاتی قابل استفاده توسط خریدار", 14, finalY);
//     doc.text("مهر و امضای فروشنده:", 14, finalY + 10);
//     doc.text("ساعت تحویل: 16:41", 100, finalY + 10);
//     doc.text("تاریخ تحویل: 1403/11/10", 160, finalY + 10);
//     doc.text("مهر و امضای خریدار:", 14, finalY + 20);
//
//     doc.save("invoice.pdf");
//   };
//
//   return (
//     <div>
//       <button onClick={generatePdf}>ساخت PDF</button>
//     </div>
//   );
// };
//
// export default ReportPdf;

import React, { useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment-jalaali";
import { numberWithSlash } from "../../utils/function.utils";

const ReportPdf = (props) => {
  const orderData = props?.data?.inputData?.order;
  let totalQuantity = 0;
  let perPriceTotal = 0;
  let totalPrice = 0;
  let discountPrice = 0;
  let priceWithDiscount = 0;
  const pdfRef = useRef();

  // تبدیل زمان یونیکس به تاریخ شمسی
  const applicationDate = moment
    .unix(orderData?.created_at)
    .format("jYYYY/jMM/jDD");

  const deliveryDate = moment
    .unix(orderData?.reservation_time_slice_id?.day)
    .format("jYYYY/jMM/jDD");

  const generatePdf = async () => {
    const element = pdfRef.current;

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pageWidth;
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("document.pdf");
  };

  return (
    <div className="p-4 relative">
      <button
        onClick={generatePdf}
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
      >
        دانلود PDF
      </button>

      {/* این بخش در موبایل مخفی است، ولی در دسکتاپ نمایش داده می‌شود */}
      <div
        ref={pdfRef}
        className="absolute left-[-9999px] md:static md:left-0 w-full p-5 bg-white rtl font-sans text-[16px] flex flex-col gap-2"
      >
        <section>
          <p className={"text-[30px] font-bold text-center mb-6"}>
            صورت حساب الکترونیکی فروش
          </p>
        </section>
        <section className={"flex gap-2"}>
          <div
            className={
              "border-2 border-black p-2 rounded-[8px] flex items-center justify-center bg-stone-300 w-[70px]"
            }
          >
            <span className={"inline-block -rotate-90 text-[14px] font-medium"}>
              فروشنده
            </span>
          </div>
          <div
            className={"border-2 border-black p-2 rounded-[8px] flex-1 flex"}
          >
            <div className={"grid grid-cols-8 gap-y-3 gap-x-4 w-full"}>
              <div className={"col-span-4"}>
                <span>نام شرکت: </span>
                <span>آسان خودرو آینده ایرانیان (سهامی خاص)</span>
              </div>
              <div className={"col-span-2"}>
                <span>شماره ملی: </span>
                <span>14011593151</span>
              </div>

              <div className={"col-span-2"}>
                <span>شماره ثبت: </span>
                <span>۶۰۳۵۲۸</span>
              </div>
              <div className={"col-start-1 col-end-5"}>
                <span>کد اقتصادی: </span>
                <span>۱۴۰۱۱۵۹۳۱۵۱</span>
              </div>
              <div className={"col-start-5 col-end-7"}>
                <span>کد پستی: </span>
                <span>۱۴۳۱۷۸۴۱۱۶</span>
              </div>
              <div className={"col-span-2"}>
                <span>تلفن: </span>
                <span>58919</span>
              </div>
              <div className={"col-span-8"}>
                <span>نشانی شرکت: </span>
                <span>
                  تهران - جهاد خیابان فتحی شقاقی ساختمان سبز پلاک 50 طبقه 3 واحد
                  14
                </span>
              </div>
            </div>
            {/*<div className={"grid grid-cols-2 flex-1"}></div>*/}
          </div>
          <div
            className={
              "border-2 border-black p-2 rounded-[8px] flex flex-col gap-3 w-[200px]"
            }
          >
            <div>
              <span>شماره فاکتور: </span>
              <span>{props?.data?.inputData?.id}</span>
            </div>
            <div>
              <span>تاریخ: </span>
              <span>{applicationDate}</span>
            </div>
            <div>
              <span>پیگیری: </span>
              <span>{orderData?.code}</span>
            </div>
          </div>
        </section>
        <section className={"flex gap-2"}>
          <div
            className={
              "border-2 border-black p-2 rounded-[8px] flex items-center justify-center bg-stone-300 w-[70px]"
            }
          >
            <span className={"inline-block -rotate-90 text-[14px] font-medium"}>
              خریدار
            </span>
          </div>
          <div
            className={"border-2 border-black p-2 rounded-[8px] flex-1 flex"}
          >
            <div className={"grid grid-cols-8 gap-y-3 gap-x-4 w-full"}>
              <div className={"col-span-4"}>
                <span>خریدار: </span>
                <span>محمد محمدی</span>
              </div>
              <div className={"col-start-5 col-end-7"}>
                <span>شماره تلفن: </span>
                <span>{orderData?.mobile_user}</span>
              </div>
              <div className={"col-span-8 self-end"}>
                <span>محل دریافت خدمات: </span>
                <span>{orderData?.address_user}</span>
              </div>
            </div>
            {/*<div className={"grid grid-cols-2 flex-1"}></div>*/}
          </div>
          <div
            className={
              "border-2 border-black p-2 rounded-[8px] flex flex-col gap-3 w-[200px]"
            }
          >
            <div>
              <span>نام خودرو: </span>
              <span>
                {orderData?.vehicle_tip?.title_brand}{" "}
                {orderData?.vehicle_tip?.title_model}
              </span>
            </div>
            <div>
              <span>کارکرد: </span>
              <span>۱۰۰۰ کیلومتر</span>
            </div>
            <div>
              <span>سال ساخت: </span>
              <span>۱۴۰۲</span>
            </div>
          </div>
        </section>

        <table className="w-full border-separate border-spacing-0 text-right text-sm border border-black rounded-lg">
          <thead>
            <tr>
              <th className="border border-black p-2 rounded-tr-[8px] text-center">
                ردیف
              </th>
              <th className="border border-black p-2 text-center">
                شناسه کالا
              </th>
              <th className="border border-black p-2 text-center">شرح کالا</th>
              <th className="border border-black p-2 text-center">تعداد</th>
              <th className="border border-black p-2 text-center">
                مبلغ واحد (ریال)
              </th>
              <th className="border border-black p-2 text-center">
                مبلغ کل (ریال)
              </th>
              <th className="border border-black p-2 text-center">
                تخفیف (ریال)
              </th>
              <th className="border border-black p-2 text-center">
                مبلغ کل پس از تخفیف (ریال)
              </th>
              <th className="border border-black p-2 text-center">
                مالیات ارزش افزوده (ریال)
              </th>
              <th className="border border-black p-2 rounded-tl-[8px] text-center">
                جمع مبلغ کل (ریال)
              </th>
            </tr>
          </thead>
          <tbody>
            {orderData?.order_items?.map((item, index) => {
              if (
                item?.orderable_type === "periodic_service" ||
                item?.orderable_type === "master"
              ) {
                totalQuantity++;
                perPriceTotal += Math.round(
                  Number(item?.price) /
                    (item?.discounted_percent === "0"
                      ? 1
                      : Number(item?.discounted_percent) / 100),
                );
                totalPrice += Math.round(
                  Number(item?.price) /
                    (item?.discounted_percent === "0"
                      ? 1
                      : Number(item?.discounted_percent) / 100),
                );
                discountPrice +=
                  Math.round(
                    Number(item?.price) /
                      (item?.discounted_percent === "0"
                        ? 1
                        : Number(item?.discounted_percent) / 100),
                  ) - Math.round(Number(item?.price));
                priceWithDiscount += Math.round(Number(item?.price));
              } else {
                totalQuantity += item?.quantity;
                perPriceTotal += Math.round(
                  Number(item?.product?.discounted_price) /
                    (1 - Number(item?.product?.discounted_percent / 100)),
                );
                totalPrice +=
                  item?.quantity *
                  Math.round(
                    Number(item?.product?.discounted_price) /
                      (1 - Number(item?.product?.discounted_percent / 100)),
                  );
                discountPrice +=
                  item?.quantity *
                    Math.round(
                      Number(item?.product?.discounted_price) /
                        (1 - Number(item?.product?.discounted_percent / 100)),
                    ) -
                  Number(orderData?.price_total);
                priceWithDiscount += Number(orderData?.price_total);
              }
              return (
                <tr>
                  <td className="border border-black p-2 text-center">
                    {index + 1}
                  </td>
                  <td className="border border-black p-2 text-center">
                    {item?.orderable_id}
                  </td>
                  <td className="border border-black p-2 text-center">
                    {item?.orderable_type === "master"
                      ? item?.package?.title
                      : `${item?.product?.product_category_name} ${item?.product?.product_brand_name}`}
                  </td>
                  <td className="border border-black p-2 text-center">
                    {item?.orderable_type === "periodic_service" ||
                    item?.orderable_type === "master"
                      ? 1
                      : item?.quantity}
                  </td>
                  <td className="border border-black p-2 text-center">
                    {item?.orderable_type === "periodic_service" ||
                    item?.orderable_type === "master"
                      ? numberWithSlash(
                          Math.round(
                            Number(item?.price) /
                              (item?.discounted_percent === "0"
                                ? 1
                                : Number(item?.discounted_percent) / 100),
                          ),
                        )
                      : numberWithSlash(
                          Math.round(
                            Number(item?.product?.discounted_price) /
                              (1 -
                                Number(
                                  item?.product?.discounted_percent / 100,
                                )),
                          ),
                        )}
                  </td>
                  <td className="border border-black p-2 text-center">
                    {item?.orderable_type === "periodic_service" ||
                    item?.orderable_type === "master"
                      ? numberWithSlash(
                          Math.round(
                            Number(item?.price) /
                              (item?.discounted_percent === "0"
                                ? 1
                                : Number(item?.discounted_percent) / 100),
                          ),
                        )
                      : numberWithSlash(
                          item?.quantity *
                            Math.round(
                              Number(item?.product?.discounted_price) /
                                (1 -
                                  Number(
                                    item?.product?.discounted_percent / 100,
                                  )),
                            ),
                        )}
                  </td>
                  <td className="border border-black p-2 text-center">
                    {item?.orderable_type === "periodic_service" ||
                    item?.orderable_type === "master"
                      ? numberWithSlash(
                          Math.round(
                            Number(item?.price) /
                              (item?.discounted_percent === "0"
                                ? 1
                                : Number(item?.discounted_percent) / 100),
                          ) - Math.round(Number(item?.price)),
                        )
                      : numberWithSlash(
                          item?.quantity *
                            Math.round(
                              Number(item?.product?.discounted_price) /
                                (1 -
                                  Number(
                                    item?.product?.discounted_percent / 100,
                                  )),
                            ) -
                            Number(orderData?.price_total),
                        )}
                  </td>
                  <td className="border border-black p-2 text-center">
                    {item?.orderable_type === "periodic_service" ||
                    item?.orderable_type === "master"
                      ? numberWithSlash(Math.round(Number(item?.price)))
                      : numberWithSlash(Number(orderData?.price_total))}
                  </td>
                  <td className="border border-black p-2 text-center">
                    {numberWithSlash(Number(0))}
                  </td>
                  <td className="border border-black p-2 text-center">
                    {item?.orderable_type === "periodic_service" ||
                    item?.orderable_type === "master"
                      ? numberWithSlash(Math.round(Number(item?.price)))
                      : numberWithSlash(Number(orderData?.price_total))}
                  </td>
                </tr>
              );
            })}
            <tr>
              <td className="border border-black p-2 text-center" colSpan={3}>
                جمع کل
              </td>
              <td className="border border-black p-2 text-center">
                {totalQuantity}
              </td>
              <td className="border border-black p-2 text-center">
                {numberWithSlash(Number(perPriceTotal))}
              </td>
              <td className="border border-black p-2 text-center">
                {numberWithSlash(Number(totalPrice))}
              </td>
              <td className="border border-black p-2 text-center">
                {numberWithSlash(Number(discountPrice))}
              </td>
              <td className="border border-black p-2 text-center">
                {numberWithSlash(Number(priceWithDiscount))}
              </td>
              <td className="border border-black p-2 text-center">
                {numberWithSlash(Number(0))}
              </td>
              <td className="border border-black p-2 text-center">
                {numberWithSlash(Number(priceWithDiscount))}
              </td>
            </tr>
            <tr>
              <td className="border border-black p-2 text-center" colSpan={5}>
                جمع کل مبلغ فاکتور به حروف
              </td>
              <td className="border border-black p-2 text-center" colSpan={5}>
                ...
              </td>
            </tr>
            <tr>
              <td
                className={
                  "border border-black border-l-transparent p-2 text-center rounded-br-[8px] pb-40 pt-5"
                }
                colSpan={3}
              >
                مهر و امضا فروشنده:
              </td>
              <td
                className={
                  "border border-black border-l-transparent border-r-transparent p-2 text-center pb-40 pt-5"
                }
                colSpan={3}
              >
                تاریخ تحویل: {deliveryDate}
              </td>
              <td
                className={
                  "border border-black border-l-transparent border-r-transparent p-2 text-center pb-40 pt-5"
                }
                colSpan={2}
              >
                ساعت تحویل: {orderData?.reservation_time_slice_id?.start_time}{" "}
                تا {orderData?.reservation_time_slice_id?.end_time}
              </td>
              <td
                className="border border-black border-r-transparent p-2 rounded-bl-[8px] text-center pb-40 pt-5"
                colSpan={2}
              >
                مهر و امضای خریدار:
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportPdf;
